import axios from 'axios'

// 创建推广链接
export const createPromotionLink = (data) =>
  axios.post('/api/promotion/link', data)

// 我的推广链接列表
export const getMyPromotionLinks = () =>
  axios.get('/api/promotion/my-links')

// 我的推广统计
export const getMyPromotionStats = () =>
  axios.get('/api/promotion/my-stats')

// 我的邀请记录（分页）
export const getMyPromotionRecords = (params) =>
  axios.get('/api/promotion/my-records', { params })

// 管理端：推广码列表
export const adminGetPromotionLinks = (params) =>
  axios.get('/api/admin/promotion/links', { params })

// 管理端：导出推广码
export const adminExportPromotionLinks = (params) =>
  axios.get('/api/admin/promotion/links/export', { params, responseType: 'blob' })

// 管理端：修改推广码
export const adminUpdatePromotionLink = (id, data) =>
  axios.put(`/api/admin/promotion/links/${id}`, data)

// 管理端：奖励记录
export const adminGetPromotionRecords = (params) =>
  axios.get('/api/admin/promotion/records', { params })

// 管理端：推广配置
export const adminGetPromotionConfig = () =>
  axios.get('/api/admin/promotion/config')

export const adminUpdatePromotionConfig = (data) =>
  axios.put('/api/admin/promotion/config', data)
